<template>
    <div :style="style">
        <Wp_grid :list="list"
                 :icon="icon"
                 :title="title"
                 :title-style="title_style"
                 :column-num="column_num"
                 :round="round"
                 :radius="radius"
                 :square="square"
                 :img-gray="imgGray"
                 @clickItem="clickGridItem"
        ></Wp_grid>
    </div>
</template>

<script>
    import Wp_grid from "../custom/Wp_grid";
    export default {
        name: "Wp_home_grid_model",
        components: {Wp_grid},

        props:{
            params:{type: Object},
            list:{type: Array},
            imgGray:{type: Boolean, default: false}
        },

        data(){
            return{
                // list:[],
                column_num: 4,
                round: false,
                radius: 0,
                square: true,
                icon: "",
                title: "",
                title_style: "",
                style: "",
            }
        },

        created() {
            this.initGridDatas();
        },

        methods:{
            initGridDatas(){
                if(this.params){
                    // if(this.params.list){
                    //     this.list = this.params.list;
                    // }
                    if(this.params.column_num){
                        this.column_num = this.params.column_num;
                    }
                    if(this.params.round){
                        this.round = this.params.round;
                    }
                    if(this.params.radius){
                        this.radius = this.params.radius;
                    }
                    if(this.params.square){
                        this.square = this.params.square;
                    }
                    if(this.params.icon){
                        this.icon = this.params.icon;
                    }
                    if(this.params.title){
                        this.title = this.params.title;
                    }
                    if(this.params.title_style){
                        this.title_style = this.params.title_style;
                    }
                    if(this.params.style){
                        this.style = this.params.style;
                    }
                }
            },

            clickGridItem(item){
                // this.$common.homeModelClickTo(item, this.$router);
                this.$clickHomeModelTo(item);
            }
        }
    }
</script>

<style scoped>

</style>